// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"57ad7779","703":"d137a7de","787":"7b06cf45"}[chunkId] + ".chunk.js";
};